"use client";
import { useEffect } from "react";
import PdpSkeleton from "./_skeleton/PdpSkeleton";

const Loading = () => {
  /**
   * Must scroll to top on load
   */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <PdpSkeleton />;
};

export default Loading;
